import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useSelector } from 'react-redux'

import { Paper, Box } from '@mui/material'
import { ApplicationState } from '@/state/root.models'
import {
  UiFeedbackContributionsComponent,
  ContributionsTableComponent,
} from './components'

import { useContributionsActions, useContributionsFilters } from './hooks'

const ContributionsModule = () => {
  const {
    getAllFreePlayContributions,
    setContributionsFilters,
    cleanContributions,
  } = useContributionsActions()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  const { contributionsFilters } = useContributionsFilters()

  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)

  const walletId = queryParams.get('id')

  useEffect(() => {
    getAllFreePlayContributions({ ...contributionsFilters, walletId })
    setContributionsFilters({ ...contributionsFilters, walletId })

    return () => {
      cleanContributions()
      setContributionsFilters({
        page: 1,
        limit: 25,
      })
    }
  }, [brand]) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      borderRadius={2}
    >
      <ContributionsTableComponent />
      <UiFeedbackContributionsComponent />
    </Box>
  )
}

export default ContributionsModule
